import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import UIRouterIconButton from 'ui-addon-react-router-dom/UIRouterIconButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import styled from '../../../utils/Styling';
const BackButton = styled((_ref) => {
  let {
    use = 'link',
    children
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["use", "children"]);

  return /*#__PURE__*/_jsxs(UIRouterIconButton, Object.assign({
    use: use
  }, props, {
    children: [/*#__PURE__*/_jsx(UIIcon, {
      name: "left"
    }), children]
  }));
}).withConfig({
  displayName: "BackButton",
  componentId: "ezh40x-0"
})(["&&{font-size:14px;text-decoration:none;font-weight:500;}"]);
export default BackButton;